// Members roster — tier + status + Stripe/Healthie IDs. Admin metadata only (no clinical data).
import { useState } from "react";
import { Link } from "react-router-dom";
import { useApi } from "../api";
import { useAsync } from "../lib/useAsync";
import { cap, shortId } from "../lib/format";
import { Loading, ErrorState, EmptyState, PageHeader, StatusBadge } from "../components/ui";

const SearchIcon = (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="11" cy="11" r="8" /><line x1="21" y1="21" x2="16.65" y2="16.65" /></svg>
);

export function Members() {
  const api = useApi();
  const { data, loading, error } = useAsync(() => api.members(), []);
  const [q, setQ] = useState("");

  if (loading) return <Loading />;
  if (error) return <ErrorState message={error} />;

  const rows = (data ?? []).filter((m) =>
    `${m.first_name} ${m.last_name} ${m.email}`.toLowerCase().includes(q.toLowerCase()),
  );

  return (
    <div className="page">
      <PageHeader title="Members" sub={`${data?.length ?? 0} members`} />
      <div className="ptbl-toolbar">
        <div className="ptbl-search">
          {SearchIcon}
          <input
            placeholder="Search members…"
            value={q}
            onChange={(e) => setQ(e.target.value)}
            aria-label="Search members"
          />
        </div>
      </div>
      <div className="ptbl-wrap">
        <table className="ptbl">
          <thead>
            <tr>
              <th>Name</th>
              <th>Tier</th>
              <th>Status</th>
              <th>Stripe</th>
              <th>Healthie</th>
            </tr>
          </thead>
          <tbody>
            {rows.length ? (
              rows.map((m) => (
                <tr key={m.id} className="ptbl-row">
                  <td>
                    <div className="ptbl-name">
                      <Link to={`/members/${m.id}`}>
                        {m.first_name} {m.last_name}
                      </Link>
                    </div>
                    <div className="ptbl-sub">{m.email}</div>
                  </td>
                  <td>{cap(m.tier)}</td>
                  <td>
                    <StatusBadge value={m.status} />
                  </td>
                  <td className="mono">{shortId(m.stripe_customer_id)}</td>
                  <td className="mono">{shortId(m.healthie_patient_id)}</td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={5}>
                  <EmptyState>No members match.</EmptyState>
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
